import { useState } from "react";
import { useParams } from "react-router-dom";
import { Drawer } from "src/components/atoms/Drawer";
import { ScrollContainer } from "src/components/containers/ScrollContainer";
import { CorporateActionCommunicationDetails } from "src/components/organisms/CorporateActionCommunicationDetails";
import { CorporateActionNotificationsTable } from "src/components/organisms/NotificationsTable/CorporateActionNotificationsTable";
import { ListNotification } from "src/store/types";

export function NotificationsTab() {
  const { id } = useParams() as { id: string };
  const [isDrawerOpen, setIsDrawerOpen] = useState(false);
  const [notification, setNotification] = useState<ListNotification | null>(
    null
  );

  const handleRowClick = (notification: ListNotification) => {
    setNotification(notification);
    setIsDrawerOpen(true);
  };

  const handleCloseDrawer = () => {
    setIsDrawerOpen(false);
    setNotification(null);
  };

  return (
    <ScrollContainer sx={{ pt: 8, pb: 10, pl: 10, pr: 6.25 }}>
      <CorporateActionNotificationsTable
        corporateActionId={id}
        onRowClick={handleRowClick}
        selectedNotification={notification}
      />
      <Drawer
        anchor="right"
        onClose={handleCloseDrawer}
        open={isDrawerOpen}
        testId="notification-detail-drawer"
      >
        {notification && (
          <CorporateActionCommunicationDetails
            activeTab="notification"
            corporateActionId={id}
            communicationId={notification.communicationIds[0]}
            notificationId={notification.id}
            onClose={handleCloseDrawer}
          />
        )}
      </Drawer>
    </ScrollContainer>
  );
}
